import { render, staticRenderFns } from "./VuesticModal.vue?vue&type=template&id=524f14eb"
import script from "./VuesticModal.vue?vue&type=script&lang=js"
export * from "./VuesticModal.vue?vue&type=script&lang=js"
import style0 from "./VuesticModal.vue?vue&type=style&index=0&id=524f14eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-modal/VuesticModal.vue
// module id = uxTM
// module chunks = 41